<template>
  <div class="permission-header">
    <v-app-bar dark dense color="#232A32">
      <!-- <v-icon>mdi-speedometer-slow</v-icon> -->
      <div class="admin__header-nav__dashboard" @click="navigateToDashboard">
        <v-icon dark color="#C6CCD0">mdi-view-dashboard</v-icon>
        <div class="admin__header-nav__dashboard_label text-button">Dashboard</div>
      </div>
      <div class="admin__header-nav__dashboard_label text-button pl-3">Admin Management</div>
    </v-app-bar>
    <v-toolbar dark dense color="#232A32">
      <v-tabs
        background-color="#232A32"
        dark
      >
        <v-tab
          v-for="route in routes"
          :key="route.name"
          :to="route.path"
        >
          {{ route.name }}
        </v-tab>
      </v-tabs>
    </v-toolbar>
  </div>
</template>

<script>
  import { ROUTES } from '@/router'

  export default {
    data () {
      return {
        routes: [ROUTES.USERS, ROUTES.PERMISSIONS],
      }
    },
    methods: {
      navigateToDashboard () {
        this.$router.push({path: '/login'})
      },
    }
  }
</script>

<style lang="scss">
  $bg-color: #435262;
  $header-nav-background-color: #232A32;
  $header-nav-font-color: #C6CCD0;

  .permission-header {
    height: 60px;
  }

  .admin {
    display: flex;
    flex-direction: column;
    background-color: $bg-color;
    color: white;
    overflow: hidden;
    height: 100%;

    &__header-nav {
      display: flex;
      font-size: 0.9em;
      background-color: $header-nav-background-color;
      height: 2.5em;
      align-items: center;
      justify-content: space-between;
      padding: 0 1.5em;

      &__dashboard {
        display: flex;
        align-items: center;
        border-right: 2px solid #435261;
        padding-right: 0.5em;
        color: $header-nav-font-color;
        min-height: 3vh;
        cursor: pointer;

        &_label {
          font-weight: bold;
          padding-left: 5px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// Header.vue?66ef27ec